import { StoreState } from '@/core/models/store.interface';
import { LocationQuery } from 'vue-router';
import { Module } from 'vuex';
import { FilterInfo, FilterInfoType } from './filter-info.interface';
import { FilterInfoService } from './filter-info.service';

const service = new FilterInfoService();

export interface FilterInfoState {
   [key: string]: FilterInfo;
}

const FilterInfoStore: Module<FilterInfoState, StoreState> = {
   namespaced: true,
   state: {},
   getters: {},
   mutations: {
      SET_FILTER_INFO(state, { filterInfo, slug }: { slug: FilterInfoType; filterInfo: FilterInfo }) {
         state[slug] = filterInfo;
      },
   },
   actions: {
      async getFiltersInfo(context, payload: { filterInfoType: FilterInfoType; query: LocationQuery }) {
         const { filterInfoType, query } = payload;
         const filterInfo = await service.getFilterInfo(filterInfoType, query);
         context.commit('SET_FILTER_INFO', { slug: filterInfoType, filterInfo });
         return filterInfo;
      },
   },
};

export default FilterInfoStore;
